import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useState } from "preact/hooks";

import cx from "classnames";

import { pageTypes } from "../../../../helpers/constants";
import Concertina from "../../../components/Concertina";
import Meta from "../Meta";
import RelatedArticle from "../RelatedArticle";
import FasterOnline from "../FasterOnline";

export interface ISuperCategory {
  superCategoryId: string;
  displayName: string;
}

export interface ISuperCategories {
  order: ISuperCategory[];
  maxResults: number;
}

export interface ICompleteOnlineUrls {
  roleId: string;
  completeOnlineUrl: string;
}

export interface IFasterOnlineRolesUrls {
  roleId: string;
  fasterOnlineUrl: string;
}

export type PageType =
  | typeof pageTypes.FAQ
  | typeof pageTypes.WEBPAGE
  | typeof pageTypes.DOCUMENT
  | typeof pageTypes.ARTICLE
  | typeof pageTypes.PEOPLE;

export interface IResult {
  pageType: PageType;
  title: string;
  description?: string;
  target?: string;
  additionalText?: string | null;
  answerText?: string | null;
  authors?: string;
  filters?: string[];
  contentUrl?: string;
  fileType?: string | null;
  jobLocation?: string | null;
  jobTitle?: string | null;
  publishDate?: string;
  lastReviewDate?: string;
  questionText?: string | null;
  readTime?: number;
  reference?: string | null;
  searchImageUrl?: string | null;
  superCategoryList: string[];
  hasExternalUrl?: boolean;
  relatedDocument?: IResult[]; // TODO: is this type correct

  fundEventType?: string | null;
  companiesImpacted?: string | null;
  effectiveDate?: string | null;
  changeDescription?: string | null;
  oldLabel?: string | null;
  oldDescription?: string | null;
  newLabel?: string | null;
  newDescription?: string | null;
  defaultAlternativeFundLabel?: string | null;
  defaultAlternativeFundDescription?: string | null;

  hasCompleteOnlineUrl: boolean;
  completeOnlineText: string | null;
  completeOnlineUrls: ICompleteOnlineUrls[] | null;
  completeOnlineOpenInSameTab: boolean;

  fasterOnlineModalActive: boolean;
  fasterOnlineUrls: IFasterOnlineRolesUrls[] | null;
  fasterOnlineModalTitle: string | null;
  fasterOnlineModalPrimaryText: string | null;
  fasterOnlineSecondaryText: string | null;
  fasterOnlineModalCtaText: string | null;
  fasterOnlineOpenInSameTab: boolean;
  fasterOnlineCtaOpenInSameTab: boolean;

  categoryList?: any[];
  filterList?: any[];
}

export interface IResultItem {
  id: string;
  title: string;
  item: IResult;
  settings: any;
  includeRelated: boolean;
  tabId: string;
}

const ResultItem: FunctionComponent<IResultItem> = ({ title, item, settings, id, includeRelated, tabId }) => {
  const { description, contentUrl, target, searchImageUrl, additionalText, fileType, pageType } = item;
  const { thumbnailFallback, thumbnails, publishDateLabel } = settings;
  const documentType = pageType === pageTypes.DOCUMENT;
  const articleType = pageType === pageTypes.ARTICLE;
  const peopleType = pageType === pageTypes.PEOPLE;
  const faqType = pageType === pageTypes.FAQ;
  const hasImage = (peopleType || articleType) && thumbnails;
  const [showModal, setShowModal] = useState(false);
  const renderPic = () => {
    if (searchImageUrl || thumbnailFallback) {
      return (
        <a
          href={contentUrl}
          className="media-block__figure media-block__figure-left search-results__image-container"
          target={target || ""}
        >
          <img
            src={searchImageUrl || thumbnailFallback}
            className="search-results__image"
            alt={peopleType ? "Headshot of " + title : title}
          />
        </a>
      );
    }
  };

  const renderFileType = () => {
    if (!fileType) {
      return;
    }
    return <span className="search-results__file-type badge">{fileType}</span>;
  };

  const updateShowModal = (state: boolean, e: any) => {
    e.preventDefault();
    setShowModal(state);
  };

  if (faqType) {
    return (
      <Concertina
        title={title}
        description={description}
        additionalText={additionalText}
        id={title.replace(/\s+/g, "")}
        isRichtext={true}
      />
    );
  }

  return (
    <div className={cx("media-block", { "media-block--grid": hasImage })}>
      {hasImage ? renderPic() : ""}
      {item.fasterOnlineModalActive && (
        <FasterOnline
          item={item}
          show={showModal}
          changeShowModal={setShowModal}
          id={(id + item.publishDate + tabId).replace(/[^a-zA-Z0-9_]/g, "")}
        />
      )}
      <div className="media-block__heading">
        <h3 className={(includeRelated ? "search-results__heading" : "related-results__heading") + " h4"}>
          {contentUrl ? (
            <a
              href={item.fasterOnlineModalActive ? "" : contentUrl}
              target={item.fasterOnlineModalActive ? "" : target}
              className={includeRelated ? "search-results__heading-link" : "related-results__heading-link"}
              onClick={item.fasterOnlineModalActive ? (e: any) => updateShowModal(true, e) : undefined}
            >
              {title}
            </a>
          ) : (
            title
          )}
          {documentType ? renderFileType() : ""}
        </h3>
      </div>

      <div className="media-block__body search-results__text">
        <Meta
          item={item}
          publishDateLabel={publishDateLabel}
        ></Meta>

        {/* {item.fileType && <div>{item.fileType}</div>} */}
        {description && <p>{description}</p>}
        {!!item.relatedDocument && includeRelated && !!item.relatedDocument.length && (
          <RelatedArticle
            item={item}
            id={id}
            title={title}
            settings={settings}
            tabId={tabId}
          />
        )}
      </div>
    </div>
  );
};

export default ResultItem;
